var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2fc;}.cls-2{fill:#61729b;}.cls-3{fill:#2c3b73;}.cls-4{fill:#d8d8fc;}.cls-5{fill:#fdbf00;}.cls-6{fill:#4bb9ec;}.cls-7{fill:#f03800;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,15.008H53.061V45.992a1,1,0,0,1-1,1h-40a1,1,0,0,1-1-1V15.008H7v34H57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,51.008v3a1,1,0,0,1-1,1H28a1,1,0,0,1-1-1v-3H5.071a7.006,7.006,0,0,0,6.929,6H52a7,7,0,0,0,6.929-6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 2,
    width: 6,
    x: 29,
    y: 51.008
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.061,12.706h-38V44.992h38ZM22.434,15.787a1,1,0,0,1,1,1V23.24h6.453a1,1,0,0,1,1,1,8.453,8.453,0,1,1-8.453-8.453Zm10.688,26.2a1,1,0,0,1-1,1h-16a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1ZM32.123,23H24.67a1,1,0,0,1-1-1V14.551a1,1,0,0,1,1-1A8.457,8.457,0,0,1,33.123,22,1,1,0,0,1,32.123,23Zm5.018,18.987a1,1,0,0,1-2,0v-6a1,1,0,0,1,2,0Zm4,0a1,1,0,0,1-2,0v-8a1,1,0,0,1,2,0Zm4,0a1,1,0,0,1-2,0v-9.5a1,1,0,0,1,2,0Zm3.981,0a1,1,0,0,1-2,0v-12a1,1,0,0,1,2,0Zm.125-15H34.918a1,1,0,0,1,0-2H49.247a1,1,0,0,1,0,2Zm0-2.857H34.918a1,1,0,0,1,0-2H49.247a1,1,0,0,1,0,2Zm0-2.857H34.918a1,1,0,0,1,0-2H49.247a1,1,0,0,1,0,2Zm0-2.857H34.918a1,1,0,0,1,0-2H49.247a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.061,6.992h-38v3.714h38ZM17.775,9.849H14.918a1,1,0,0,1,0-2h2.857a1,1,0,0,1,0,2Zm5.715,0H20.632a1,1,0,0,1,0-2H23.49a1,1,0,0,1,0,2Zm5.714,0H26.347a1,1,0,1,1,0-2H29.2a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,49.008H59v-35a1,1,0,0,0-1-1H53.061V5.992a1,1,0,0,0-1-1h-40a1,1,0,0,0-1,1v7.016H6a1,1,0,0,0-1,1v35H4a1,1,0,0,0-1,1,9,9,0,0,0,9,9H52a9,9,0,0,0,9-9A1,1,0,0,0,60,49.008Zm-8,8H12a7.006,7.006,0,0,1-6.929-6H27v3a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-3H58.929A7,7,0,0,1,52,57.008Zm-38.939-44.3h38V44.992h-38Zm0-5.714h38v3.714h-38ZM7,15.008h4.061V45.992a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V15.008H57v34H7Zm22,36h6v2H29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.775,7.849H14.918a1,1,0,0,0,0,2h2.857a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.49,7.849H20.632a1,1,0,0,0,0,2H23.49a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.2,7.849H26.347a1,1,0,1,0,0,2H29.2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.434,30.694A6.459,6.459,0,0,0,28.81,25.24H22.434a1,1,0,0,1-1-1V17.864a6.454,6.454,0,0,0,1,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.434,32.694a8.457,8.457,0,0,0,8.453-8.453,1,1,0,0,0-1-1H23.434V16.787a1,1,0,0,0-1-1,8.453,8.453,0,1,0,0,16.907Zm-1-14.83V24.24a1,1,0,0,0,1,1H28.81a6.454,6.454,0,1,1-7.376-7.376Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.669,15.628V21h5.376A6.464,6.464,0,0,0,25.669,15.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.67,13.551a1,1,0,0,0-1,1V22a1,1,0,0,0,1,1h7.453a1,1,0,0,0,1-1A8.457,8.457,0,0,0,24.67,13.551Zm1,7.453V15.628A6.464,6.464,0,0,1,31.046,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.141,34.992a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0v-6A1,1,0,0,0,36.141,34.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.141,32.992a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0v-8A1,1,0,0,0,40.141,32.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.141,31.492a1,1,0,0,0-1,1v9.5a1,1,0,0,0,2,0v-9.5A1,1,0,0,0,44.141,31.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.122,28.992a1,1,0,0,0-1,1v12a1,1,0,0,0,2,0v-12A1,1,0,0,0,48.122,28.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.247,16.421H34.918a1,1,0,0,0,0,2H49.247a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.247,19.278H34.918a1,1,0,0,0,0,2H49.247a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.247,22.135H34.918a1,1,0,0,0,0,2H49.247a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.247,24.992H34.918a1,1,0,0,0,0,2H49.247a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 4,
    width: 14,
    x: 17.122,
    y: 36.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.122,34.992h-16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1v-6A1,1,0,0,0,32.122,34.992Zm-1,6h-14v-4h14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e8d0afba72b9114976a7b6d1af79e17d.svg";
export { ForwardRef as ReactComponent };